import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { Container, Row, Col, Tab, Tabs } from 'react-bootstrap';
import login from '../../assets/img/login.svg'
import back from '../../assets/img/icons/back.svg'
import Signin from './signin';
import Signup from './signup';
import imagelogo from '../../assets/img/imagelogo.svg'
import Select from 'react-select';
import Cookies from 'universal-cookie';
import ls from "local-storage";
import { options } from "../../config/options";
import { Trans } from "react-i18next";
import "../../config/i18n";
import { withTranslation } from "react-i18next";

const selectStyles = {
    control: (base) => ({
        ...base,
        fontSize: '14px',
        fontWeight: 'Regular',
        borderRadius: '6px',
        border: '1px solid #7E838D !important',
        boxShadow: 'none',
        '&:focus': {
            border: '0 !important',
        },
    }),
    option: (base) => ({
        ...base,
        cursor: "pointer",
        background: "white",
        color: "#000",
        ":hover": {
            backgroundColor: "#FFE6EE",
        },
    })
}

class WelcomeIndex extends Component {

    constructor(props) {
        super(props);
        this.state = {
            key: 'signin',
            language: ls.get('LangKeySet') || options[0],
            langKey: ls.get('LangValue')
        };
    }

    componentDidMount() {
        if (this.props.i18n.language) {
			this.setState({
                language: this.props.i18n.language,
            });
		}
        if (this.state.language === 'ar' || this.state.language === 'he') {
            document.body.dir = 'rtl';
            document.body.classList.add('rtl');
            document.body.classList.remove('ltr')
        } else {
            document.body.dir = 'ltr';
            document.body.classList.remove('rtl');
            document.body.classList.add('ltr');
        }
        const cookies = new Cookies();
        var signuptab = cookies.get('signuptab');
        if(signuptab === 'yes'){
			this.setState({
				key:'signup',
			});
		}
    }

    handleLanguageChange = (selectedOption) => {
        console.log("handleLanguageChange: ", selectedOption);
        const { i18n } = this.props;
        const language = selectedOption.value;
        i18n.changeLanguage(language);
        this.setState({ language });
        ls.set('LangKeySet', language);
        ls.set('LangValue', language);
		window.location.reload();
        if (language === 'ar' || language === 'he') {
            document.body.dir = 'rtl';
            document.body.classList.add('rtl');
            document.body.classList.remove('ltr')
        } else {
            document.body.dir = 'ltr';
            document.body.classList.remove('rtl');
            document.body.classList.add('ltr');
        }
    }

    render() {
        const { key, language } = this.state;
        const layoutClassName = language === 'ar' ? 'layout layout-arabic' : 'layout';

        return (
            <div className={layoutClassName}>
                <Container>
                    <div className='welcome_header'>
                        <div className='welcomeheader_left'>
                            <a href='https://kabadate.com/' style={{cursor: 'pointer'}}>
                                <img src={back} alt="img" />
                            </a>
                            <a href='https://kabadate.com/' style={{cursor: 'pointer'}}>
                                <img src={imagelogo} alt="img" className='image_logo' />
                            </a>
                        </div>
                        <div>
                            <Select
                                isSearchable={false}
                                styles={selectStyles}
                                className="header_Select"
                                options={options}
                                onChange={this.handleLanguageChange}
                                value={options.find(option => option.value === language)}
                            />
                        </div>
                    </div>

                </Container>
                <div className='welcome_bodydiv'>
                    <Container>
                        <Row className='aligned_center'>
                            <Col md={6} sm={6}>
                                <div className="login-image">
                                    <img src={login} alt="img" />
                                </div>
                            </Col>
                            <Col md={6} sm={6}>
                                <div className='login-tab'>
                                    <Tabs
                                        id="controlled-tab-example"
                                        activeKey={key}
                                        onSelect={(k) => this.setState({ key: k })}
                                        className='login_tab_div'
                                    >
                                        <Tab eventKey="signin" title={<Trans i18nKey="signin">Sign In</Trans>}>
                                            <Signin />
                                        </Tab>
                                        <Tab eventKey="signup" title={<Trans i18nKey="signup">Sign Up</Trans>}>
                                            <Signup />
                                        </Tab>

                                    </Tabs>
                                </div>

                            </Col>
                        </Row>
                    </Container>
                </div>
            </div >
        );
    }
}

export default withTranslation("translations")(WelcomeIndex);
